import React, {useState, useEffect, useRef, useContext} from 'react';

import {AppContext} from '../../../AppModule/Context';

import TextPillComponent from './components/textPillComponent';

import utilsService from '../../../services/utilsService';

import './multipleTextPillComponent.css';

const MultipleTextPillComponent = ({
  isDisabled = false,
  disableAdditionOfTextPills = false,
  showError = false,
  showStatusIcon = true,
  newRecipientEmail = '',
  placeholder = '',
  recipients = [],
  addRecipientEmail = () => {},
  editRecipientEmail = () => {},
  removeRecipient = () => {},
  setNewRecipientEmail = () => {},
}) => {
  const context = useContext(AppContext);

  const [isFocused, setIsFocused] = useState(false);
  const [showAddTextPill, setShowAddTextPill] = useState(false);
  const addTextPillInputRef = useRef();

  useEffect(() => {
    window.addEventListener('click', handleOutsideEvent);
    return () => {
      window.removeEventListener('click', handleOutsideEvent);
    };
  }, [newRecipientEmail, disableAdditionOfTextPills]);

  useEffect(() => {
    const validEmail = getValidText(newRecipientEmail);
    setNewRecipientEmail(validEmail);
  }, [newRecipientEmail]);

  const handleOutsideEvent = (e) => {
    if (!disableAdditionOfTextPills) {
      const classOfElement = e.target.getAttribute('class');
      if (
        classOfElement?.includes('et-n-melc-container') ||
        classOfElement?.includes('et-n-epc-email-input') ||
        classOfElement?.includes('et-n-melc-placeholder-txt')
      ) {
        setShowAddTextPill(true);
        setIsFocused(true);
        addTextPillInputRef?.current?.focus();
      } else {
        setShowAddTextPill(false);
        setIsFocused(false);
        addRecipientEmail();
      }
    }
  };

  const copyEmailToClipboard = (recipientEmail) => {
    if (recipientEmail.length > 0) {
      utilsService.copyTextToClipboard(recipientEmail);
      const toastObj = utilsService.getToastObj({toastTitle: 'Copied'});
      context.addToastObj(toastObj);
    }
  };

  const getValidText = (pillText) => {
    return pillText.replace(/[\s,;]/g, '');
  };

  return (
    <div
      className={`et-n-melc-container ${
        isFocused ? 'et-n-melc-container-focused' : ''
      }  ${showError ? 'et-n-melc-container-erroneous' : ''} ${
        isDisabled ? 'et-n-melc-container-disabled' : ''
      }`}>
      {placeholder.length > 0 && !isFocused && recipients.length === 0 && (
        <div className="et-n-melc-placeholder-txt">{placeholder}</div>
      )}
      {recipients.map((recipient, idx) => (
        <TextPillComponent
          key={idx}
          hideDeleteIcon={isDisabled}
          showStatusIcon={showStatusIcon}
          email={recipient.email}
          recipientStatus={recipient.status}
          isValid={recipient.isValid}
          onChange={(email) => {
            const validEmail = getValidText(email);
            editRecipientEmail(idx, validEmail);
          }}
          onDoubleClick={copyEmailToClipboard}
          removeRecipient={() => {
            removeRecipient(idx);
          }}
        />
      ))}
      {showAddTextPill && !disableAdditionOfTextPills && (
        <TextPillComponent
          isAddEmailPill
          showStatusIcon={false}
          addTextPillInputRef={addTextPillInputRef}
          email={newRecipientEmail}
          onChange={setNewRecipientEmail}
          onKeyDown={addRecipientEmail}
          onDoubleClick={copyEmailToClipboard}
        />
      )}
    </div>
  );
};

export default MultipleTextPillComponent;
